<template>
  <table
    ref="table"
    class="sf-table sf-table-border sf-full-width"
    :class="tableClass"
  >
    <thead>
      <slot
        name="columns"
        :headers="headers"
        :sort-direction="sortDirection"
        :sort-by="sortBy"
      >
        <sf-table-headers
          :headers="headers"
          :sort-direction="sortDirection"
          :sort-by="sortBy"
          @header-click="headerClick"
        >
          <template #header="{ header, headerIndex, headerLabel }">
            <slot
              name="header"
              :header="header"
              :header-index="headerIndex"
              :header-label="headerLabel"
              :sort-by="sortBy"
              :sort-direction="sortDirection"
              :max-header-cell-width="maxHeaderCellWidth"
              :non-sortable-headers="nonSortableHeaders"
            />
          </template>
        </sf-table-headers>
      </slot>
    </thead>
    <tbody>
      <slot name="rows" :rows="effectiveData">
        <tr
          v-for="{ id, ...rowItems } = {} in effectiveData"
          :key="id"
          data-testid="sf-table-row"
        >
          <slot :id="id" name="row" :row-data="rowItems">
            <sf-table-row :row-data="rowItems" />
          </slot>
        </tr>
      </slot>
    </tbody>
  </table>
</template>
<script>
import sfTableHeaders from './sf-table-headers'
import sfTableRow from './sf-table-row'
import { tableSortDirections } from './../constants'

export default {
  name: 'SfTable',
  components: {
    'sf-table-headers': sfTableHeaders,
    'sf-table-row': sfTableRow,
  },
  props: {
    autoHeaderCellWidth: {
      type: Boolean,
      default: false,
    },
    handlesSorting: {
      type: Boolean,
      default: true,
    },
    headers: {
      type: Array,
      default: function () {
        return []
      },
    },
    initialSortBy: {
      type: String,
      default: function () {
        return ''
      },
    },
    initialSortDirection: {
      type: String,
      default: tableSortDirections.ASC,
    },
    layout: {
      type: String,
      default: 'auto',
    },
    rows: {
      type: Array,
      default: function () {
        return []
      },
    },
    nonSortableHeaders: {
      type: Array,
      default: function () {
        return []
      },
    },
    stickyHeader: {
      type: Boolean,
    },
  },
  emits: ['table-sort'],
  data() {
    return {
      sortBy: this.initialSortBy,
      sortDirection: this.initialSortDirection,
      maxHeaderCellWidth: 0,
    }
  },
  computed: {
    effectiveData: function () {
      return this.handlesSorting ? this.sortedData : this.rows
    },
    sortedData: function () {
      const sortedRows = this.rows
      return sortedRows.sort((a, b) => {
        if (a[this.sortBy] < b[this.sortBy])
          return -1 * (this.sortDirection === tableSortDirections.DESC ? -1 : 1)
        if (a[this.sortBy] > b[this.sortBy])
          return 1 * (this.sortDirection === tableSortDirections.DESC ? -1 : 1)
        return 0
      })
    },
    tableClass: function () {
      return {
        'columns-auto-width': this.layout === 'fixed',
        'sf-table-sticky': this.stickyHeader,
      }
    },
  },
  mounted() {
    if (!this.autoHeaderCellWidth) {
      return null
    }

    const tableElement = this.$refs.table

    if (!tableElement) {
      return null
    }

    const tableWidth = tableElement.offsetWidth

    this.maxHeaderCellWidth = Math.floor(tableWidth / this.headers.length)
  },
  methods: {
    headerClick(value) {
      if (this.nonSortableHeaders.includes(value)) {
        return
      }

      if (value === this.sortBy) {
        this.sortDirection =
          this.sortDirection === tableSortDirections.ASC
            ? tableSortDirections.DESC
            : tableSortDirections.ASC
      }

      this.sortBy = value

      if (!this.handlesSorting) {
        this.$emit('table-sort', {
          sortBy: this.sortBy,
          sortDirection: this.sortDirection,
        })
      }
    },
  },
}
</script>
